export const expo = (n: number | string, decimal?: number): string => {
  return Number(n).toExponential(decimal);
};

export const moneyToString = (value: number): string =>
  `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

export const stringToMoney = (value: string): string => value.replace(/\$\s?|(,*)/g, '');
